import RenderZipAndLocations from './RenderZipAndLocations'

export default RenderZipAndLocations
